import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Input, inject, Output, EventEmitter, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';

import { PaginatedAlbumTemplateRecursiveList } from '@offconon/core-api';
import { MediaFolderFormCommonComponent } from '@offconon/shared/ui/media-album-form-common';

import { deleteSelectedFolderFromStorage } from '../../../store/media-gallery.actions';
import { FolderTreeComponent } from '../folder-tree/folder-tree.component';

@Component({
  selector: 'offconon-media-folder-content-album-card',
  templateUrl: './media-folder-content-album-card.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    PaginatorModule,
    DragDropModule,
    MatIcon,
    TooltipModule,
    ButtonModule,
    MenuModule,
    ConfirmDialogModule,
    FolderTreeComponent,
    DialogModule,
    PopoverModule,
    MediaFolderFormCommonComponent,
  ],
  styles: ``,
})
export class MediaFolderContentAlbumCardComponent implements OnInit {
  @Input() data: any;
  @Input() selectedAlbumId: any;
  @Input() folderList: PaginatedAlbumTemplateRecursiveList | undefined;
  @Input() media: any;
  @Input() editFolder = false;
  @Input() user_id: number = 0;
  @Input() business_id: any = null;
  @Input() album_id: number = 0;
  @Output() selectedItemEmit = new EventEmitter<any>();
  @Output() selectedFolderEmit = new EventEmitter<any>();
  @Output() movedFolderEmit = new EventEmitter<any>();
  @Output() editedFolderEmit = new EventEmitter<any>();
  @Output() deleteFolderEmit = new EventEmitter<any>();
  @Output() editFolderEmit = new EventEmitter<any>();

  private messageService = inject(MessageService);
  private store = inject(Store);
  private translateService = inject(TranslateService);
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);
  items: MenuItem[];
  pageSize = 10;
  page: number = 1;
  loading = false;
  selectFolder = false;
  copyAction = false;
  editProperty = false;
  public datas: any;
  public results: any;
  public selectedIds: number[] = [];
  public selectedItem: any[] = [];

  ngOnInit(): void {
    this.datas = [];
    this.results = [];
    this.renderMenu(this.media);
  }

  onDragStart(event: DragEvent, media: any) {
    if (media.media_file_type) {
      event.dataTransfer?.setData('mediaId', media.id);
    } else {
      event.dataTransfer?.setData('albumId', media.id);
    }

    event.dataTransfer?.setData('mediaType', media.media_file_type);
  }

  selectedFolderId(item: any) {
    this.selectedFolderEmit.emit(item);
  }

  closeEditDialog() {
    this.editFolder = false;
    this.editedFolderEmit.emit(true);
  }

  savedForm(event: any) {
    this.data.name = event;
    this.closeEditDialog();
  }
  onlyCloseDialog() {
    this.selectFolder = false;
  }
  closeDialog() {
    this.selectFolder = false;
    this.movedFolderEmit.emit(this.data.id);
  }

  deleteFolder() {
    if (this.data) {
      let media_id: number = this.data.id;
      this.confirmationService.confirm({
        message: this.translate.instant('Are you sure you want to delete this?'),
        header: this.translate.instant('Attention'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.store.dispatch(deleteSelectedFolderFromStorage({ id: media_id }));
          setTimeout(() => {
            this.deleteFolderEmit.emit(media_id);
          }, 200);

          this.messageService.add({
            severity: 'info',
            summary: this.translate.instant('Successful'),
            detail: this.translate.instant('Your request has been successfully completed.'),
          });
        },
        key: 'deletefolder-' + this.data.id,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('Error'),
        detail: this.translate.instant('No selected item found!'),
      });
    }
  }
  showFolders() {
    this.selectFolder = true;
  }
  editProperties(_data: any) {
    this.editFolder = true;
  }
  onlyCloseEditDialog() {
    this.editFolder = false;
  }

  renderMenu(data: any) {
    this.items = [
      {
        label: this.translateService.instant('Manage'),
        visible: data,
        items: [
          {
            label: this.translateService.instant('Edit Folder'),
            icon: 'edit',
            visible: data,
            command: () => {
              this.editProperties(data);
            },
          },
          {
            label: this.translateService.instant('Move'),
            icon: 'send',
            visible: data,
            command: () => {
              this.copyAction = false;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Delete'),
            icon: 'delete',
            icon_color: 'text-red-500',
            visible: data,
            command: () => {
              this.deleteFolder();
            },
          },
        ],
      },
    ];
  }
}
